import { Locale, type LocalizedString } from "./Locale.js";

export const localeLangMap = {
	[Locale.cs]: "cs",
	[Locale.en]: "en",
	[Locale.pl]: "pl",
	[Locale.de]: "de",
	[Locale.hu]: "hu",
} satisfies LocalizedString;
